module.exports = __webpack_public_path__ + "media/reportAssets/SurveyOVERVIEW-6180e1f7.png";